import styled from "styled-components";
import {
  createSelectColumn,
  MbjButton,
  MbjFlex,
  MbjLink,
  MbjLoading,
  MbjNavPath,
  MbjScrollArea, MbjTableV2, MbjWidgetClassic
} from "@mbj-front-monorepo/ui";
import {useLocation} from "react-router-dom";
import {
  useGetCvTheque,
  useGetCvThequeAlliance,
  useGetMemberAlliances,
  useGetMemberMe
} from "@mbj-front-monorepo/data-access";
import {
  createColumnHelper,
  getCoreRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable
} from "@tanstack/react-table";
import {getDateFR, GetElementType} from "@mbj-front-monorepo/utils";
import * as React from "react";
import {GoPlus} from "react-icons/go";
import {useMemo} from "react";

interface AllianceCvThequeCtrlProps{
  className?:string;
}

const AllianceCvThequeCtrl = (props:AllianceCvThequeCtrlProps)=>{
  const CvQuery = useGetCvThequeAlliance();
  const alliancesQuery = useGetMemberAlliances();
  const memberQuery = useGetMemberMe();
  const ListCv = useMemo(()=>{
    if(!CvQuery.data || !memberQuery.data || !alliancesQuery.data){
      return []
    } else {
      const mesAlliancesID = alliancesQuery.data.filter(a=>a.Alliance).map(a=>a.Alliance?.id||0)
      console.log(mesAlliancesID);
      return CvQuery.data.filter(cv=>{
          const ThisAlliances = cv.alliances;
          console.log(ThisAlliances);
          if(ThisAlliances){
            let nb = 0;
            ThisAlliances.forEach(ida=>{
              if(mesAlliancesID.indexOf(parseInt(ida))!==-1){
                console.log("troue "+cv.id)
                nb++;
              }
            })
            if(nb>0){
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
      })
    }
  }, [CvQuery.data, memberQuery.data, alliancesQuery.data])

  const columnHelper = createColumnHelper<GetElementType<typeof CvQuery.data>>();
  const columns = [
    createSelectColumn(columnHelper),
    columnHelper.group({
      header: "Identité",
      columns: [
        columnHelper.accessor((row) => row.nom, {
          header: "Nom",
          cell: (info) => <MbjLink to={info.row.original.id?.toString() || "0"}>{info.getValue()}</MbjLink>,
        }),
        columnHelper.accessor((row) => row.prenom, {
          header: "Prénom",
        }),
      ],
    }),
    columnHelper.group({
      header: "Localisation",
      columns: [
        columnHelper.accessor((row) => row.adresse || "--", {
          header: "Adresse",
        }),
        columnHelper.accessor((row) => row.codepostal || "--", {
          header: "Code Postal",
        }),
        columnHelper.accessor((row) => row.ville || "--", {
          header: "Ville",
        }),
      ],
    }),
  ];

  const table = useReactTable({
    data: ListCv,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: false,
    initialState: {
      sorting: [{ id: "Nom", desc: false }],
    },
  });
  const DeleteOne = ()=>{
    console.log('deleting')
  }
  const AddOne = ()=>{
    console.log('Adding')
  }
  return (
    <div className={`ma_cv_theque ${props.className}`}>
      <MbjWidgetClassic title="CvThèque de l'alliance" bodyGrow={1} grow={1} bodyDirection={"column"} bodyNoWrap>
        {CvQuery.isLoading ? (
          <MbjLoading />
        ) : CvQuery.isError ? (
          <p>Error !</p>
        ) : (
          <>
            <div className={"space-between"}>
              <div className={"ResultNumber"}>{table.getRowModel().rows.length} résultats</div>
            </div>
            <MbjScrollArea overflowX={"auto"} maxHeight={"350px"}>
              <MbjTableV2 table={table} Multiple={true}/>
            </MbjScrollArea>
          </>
        )}
      </MbjWidgetClassic>

    </div>
  )
}

export const AllianceCvTheque = styled(AllianceCvThequeCtrl)`
  padding: 1% 2%;
  display: flex!important;
  flex-direction: column;
  height: 100%;

  .ResultNumber{
    font-size:20px;
  }
  .space-between{
    display:flex;
    justify-content: space-between;
    align-items: center;
}
`

